import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Button,
  IconButton
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { Visibility, Print,Sync,ArrowBack } from '@mui/icons-material';
import api from "./api/apiClient";
import apiClient from "./api/apiClient";
import moment from 'moment';

const ManualAllocateToFe = () => {
  const [unallocatedChecks, setUnallocatedChecks] = useState([]);
  const [allocatedChecks, setAllocatedChecks] = useState([]);
  const [completedChecks, setCompletdChecks] = useState([]);
  const [insuffChecks, setInsuffChecks] = useState([]);
  const [rejectedChecks, setRejectedChecks] = useState([]);
  const [selectedCheckIds, setSelectedCheckIds] = useState([]);
  const [selectedChecks, setSelectedChecks] = useState([]);
  const [feList, setFeList] = useState([]);
//  const [selectedTl, setSelectedTl] = useState("");
  const [selectedFe, setSelectedFe] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    fetchAddressChecks();
    fetchFes();
  }, []);

  const getFeName = (feId)=>{
    console.log("Name required for tlId ",feId);
    for(let i=0; i < feList.length;i++){
      let item = feList[i];
      if(item.id === feId){
        console.log("Returning name ",item.name);
        return item.name;
      }      
    }

  }
  const fetchAddressChecks = async () => {
    try {
/*      const unallocatedRes = await api.get("/addresscheckone/unallocated");
      const allocatedRes = await api.get("/addresscheckone/allocated");
      setUnallocatedChecks(unallocatedRes.data);
      setAllocatedChecks(allocatedRes.data);*/
      let response = await api.get(`/addresscheckones/casestoallocatetofe/${localStorage.getItem("userId")}`);
      let allocated = []
      let unallocated = []
      let completed = []
      let insuff = []
      let rejected = []

      response.data.forEach(check=>{
          if(check.allocatedToFe === null){
            unallocated.push(check);
          }else if (check.status.trim().toUpperCase() === 'ALLOCATED-TO-FE' || check.status.toUpperCase() == 'FE-DOWNLOADED'){
            allocated.push(check)
          }else if (check.status.trim().toUpperCase() === 'COMPLETED'){
            completed.push(check)
          }else if(check.status.trim().toUpperCase() === 'INSUFFICIENCY' || check.status.toUpperCase() === 'COULD-NOT-VERIFY'){
            insuff.push(check)
          }else{
            rejected.push(check)
          } 
      })
      setUnallocatedChecks(unallocated);
      setAllocatedChecks(allocated);
      setCompletdChecks(completed);
      setInsuffChecks(insuff)
      setRejectedChecks(rejected)
    } catch (error) {
      console.error("Error fetching address checks", error);
    }
  };

  const fetchFes = async () => {
    try {
      let userId = localStorage.getItem("userId");
      const response = await api.get(`/users/reportees/${userId}`);
      setFeList(response.data);
    } catch (error) {
      console.error("Error fetching TL list", error);
    }
  };

  const handleCheckToggle = (check) => {
    const key = getUniqueCheckKey(check);
    setSelectedChecks((prev) => {
      const exists = prev.find((c) => getUniqueCheckKey(c) === key);
      return exists
        ? prev.filter((c) => getUniqueCheckKey(c) !== key)
        : [...prev, check];
    });
  };
  

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setSelectedCheckIds([]); // Clear selection on tab switch
  };
  const navigate = useNavigate();

  const handleViewDetails = (check) => {
    let caseId = check.caseId;
    let checkType = check.checkType;
    let checkId = check.checkId;
    navigate(`/addresscheckonedetails/`,{ state: { caseId, checkType, checkId }});
  };
  
  const handlePrintReport = async(check) => {
    try {
/*      const geocodeResponse = await apiClient.get('https://maps.googleapis.com/maps/api/geocode/json',{params: {address: check.address,key:'AIzaSyBuPHXdoghVtbCn2NEWt_YcVgbrohMaIPI',},});
      const geocodeResponseData = geocodeResponse.data;
      if (geocodeResponseData.status === 'OK' && geocodeResponseData.results.length > 0) {
        console.log("Response from geocode ",geocodeResponseData.results);
        const { lat, lng } = geocodeResponseData.results[0].geometry.location;
        console.log("latitude is ",lat," longitude is ",lng);
//        alert("latitude is "+ lat + "longitude is " +lng );

      } else if (geocodeResponseData.status === 'ZERO_RESULTS') {
        alert('No results found for the given address.');
      } else {
        alert(`Geocoding API error: ${geocodeResponseData.status}`);
      }*/
      const response = await apiClient.get(`/addresscheckones/downloadreport?caseId=${encodeURIComponent(check.caseId)}&checkType=${encodeURIComponent(check.checkType)}&checkId=${check.checkId}`,{ responseType: 'blob' } );
      console.log("Got Response",response)
      if (!response) {
        throw new Error('Failed to download report');
      }
  
      const blob = await response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
  
      a.href = url;
  
      // Extract filename from Content-Disposition header, if available
      const disposition = response.headers['content-disposition'];
      let filename = `report_${check.caseId}.pdf`;
  
      if (disposition && disposition.includes('filename=')) {
        filename = disposition
          .split('filename=')[1]
          .split(';')[0]
          .replace(/["']/g, '');
      }
  
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the report:', error);
      alert('Failed to download report. Please try again.');
    }
  };
  
  const getUniqueCheckKey = (check) =>
  `${check.caseId}__${check.checkType}__${check.checkId}`;


  const renderTable = (data, showAllocatedTo = false, showCheckbox = false, currentTab = 0) => (
    <TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: "auto" }}>
      <Table stickyHeader size="small">
        <TableHead>
        <TableRow>
            {showCheckbox && <TableCell />}
            <TableCell>Case ID</TableCell>
            <TableCell>Check Type</TableCell>
            <TableCell>Check ID</TableCell>
            <TableCell>Candidate Name</TableCell>
            <TableCell>Address</TableCell>
            <TableCell>City</TableCell>
            <TableCell>PIN</TableCell>
            <TableCell>Status</TableCell>
            {showAllocatedTo && <TableCell>Allocated To</TableCell>}
            {(currentTab === 2 || currentTab === 3 || currentTab === 4) && (
              <>
                <TableCell>Completion Date</TableCell>               
                <TableCell>Details</TableCell>
                <TableCell>Print</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((check) => (
            <TableRow key={getUniqueCheckKey(check)} hover>
            {showCheckbox && (
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedChecks.some((c) => getUniqueCheckKey(c) === getUniqueCheckKey(check))}
                  onChange={() => handleCheckToggle(check)}
                />
              </TableCell>
            )}
            <TableCell>{check.caseId}</TableCell>
            <TableCell>{check.checkType}</TableCell>
            <TableCell>{check.checkId}</TableCell>
            <TableCell>{check.candidateName}</TableCell>
            <TableCell>{check.address}</TableCell>
            <TableCell>{check.city}</TableCell>
            <TableCell>{check.pin}</TableCell>
            <TableCell>{check.status}</TableCell>
            {showAllocatedTo && <TableCell>{getFeName(check.allocatedToFe)}</TableCell>}
            {(currentTab === 2 || currentTab === 3 || currentTab === 4) && (
              <>
               <TableCell>
                 {check.geotagTimestamp != null ? moment(check.geotagTimestamp).format("DD-MMM-YYYY"):""}
               </TableCell>              
                <TableCell>
                  <Button onClick={() => handleViewDetails(check)}>
                    <Visibility />
                  </Button>
                </TableCell>
                <TableCell>
                  <Button onClick={() => handlePrintReport(check)}>
                    <Print />
                  </Button>
                </TableCell>
              </>
            )}
          </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const isButtonDisabled = selectedChecks.length === 0 || !selectedFe;

  const handleAllocateChecks = async()=>{
    console.log("Allocate:", selectedChecks, "to TL:", selectedFe);
    try{
      let response = await api.put(`/addresscheckones/assigntofe/${selectedFe}`,selectedChecks);
      await fetchAddressChecks();
      setSelectedChecks([]); 
    } catch(error){
      console.log("Error allocating checks",error);
    }  
  }
  const handleReAllocateChecks = async () => {
    console.log("Re-Allocate:", selectedChecks, "to TL:", selectedFe);
    try {
      let response = await api.put(`/addresscheckones/assigntofe/${selectedFe}`, selectedChecks);
      await fetchAddressChecks();
      setSelectedChecks([]);
    } catch (error) {
      console.error("Error reallocating checks", error);
    }
  };
  const handleBack = () => {
    navigate(-1); // Navigate to previous screen
  };  
  return (
    <Box sx={{ width: "95%", margin: "auto", mt: 4 }}>
{/*      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
         <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Manual Allocation to FE
        </Typography>
        <IconButton onClick={fetchAddressChecks} aria-label="refresh">
          <Sync />
        </IconButton>
  </Box> */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={handleBack}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: "bold", ml: 1 }}>
              Manual Allocation to FE
            </Typography>
          </Box>
          <IconButton onClick={fetchAddressChecks} aria-label="refresh">
            <Sync />
          </IconButton>
        </Box>

{/*      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Unallocated" />
        <Tab label="Allocated" />
        <Tab label="Completed" />
        <Tab label="Insuff" />        
        <Tab label="Rejected" />                
  </Tabs>*/}
    <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
       <Tab label={`Unallocated${unallocatedChecks.length > 0 ? ` (${unallocatedChecks.length})` : ''}`} />
       <Tab label={`Allocated${allocatedChecks.length > 0 ? ` (${allocatedChecks.length})` : ''}`} />
       <Tab label={`Completed${completedChecks.length > 0 ? ` (${completedChecks.length})` : ''}`} />
       <Tab label={`Insuff${insuffChecks.length > 0 ? ` (${insuffChecks.length})` : ''}`} />
       <Tab label={`Rejected${rejectedChecks.length > 0 ? ` (${rejectedChecks.length})` : ''}`} />
   </Tabs>
      {tabIndex === 0 && renderTable(unallocatedChecks, false, true, tabIndex)}
      {tabIndex === 1 && renderTable(allocatedChecks, true, true, tabIndex)}
      {tabIndex === 2 && renderTable(completedChecks, true, true, tabIndex)}
      {tabIndex === 3 && renderTable(insuffChecks, true, true, tabIndex)}
      {tabIndex === 4 && renderTable(rejectedChecks, true, true, tabIndex)}


      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="fe-select-label">Select FE</InputLabel>
          <Select
            labelId="fe-select-label"
            value={selectedFe}
            label="Select FE"
            onChange={(e) => setSelectedFe(e.target.value)}
          >
            {feList.map((fe) => (
              <MenuItem key={fe.id} value={fe.id}>
                {fe.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {tabIndex === 0 && (
          <Button
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
            onClick={handleAllocateChecks}
          >
            Allocate
          </Button>
        )}

        {tabIndex === 1 && (
          <Button
            variant="contained"
            color="secondary"
            disabled={isButtonDisabled}
            onClick={handleReAllocateChecks}
          >
            Re-Allocate
          </Button>
        )}

        {tabIndex === 2 && (
          <Button
            variant="contained"
            color="secondary"
            disabled={isButtonDisabled}
            onClick={() => {
              console.log("Re-Allocate:", selectedCheckIds, "to TL:", selectedFe);
              // Add your API call for re-allocation here
            }}
          >
            Re-Allocate
          </Button>
        )}        

        {tabIndex === 3 && (
          <Button
            variant="contained"
            color="secondary"
            disabled={isButtonDisabled}
            onClick={() => {
              console.log("Re-Allocate:", selectedCheckIds, "to TL:", selectedFe);
              // Add your API call for re-allocation here
            }}
          >
            Re-Allocate
          </Button>
        )}             
        {tabIndex === 4 && (
          <Button
            variant="contained"
            color="secondary"
            disabled={isButtonDisabled}
            onClick={handleReAllocateChecks}
          >
            Re-Allocate
          </Button>
        )}                   
      </Box>
    </Box>
  );
};

export default ManualAllocateToFe;
